import { createContext, type ReactNode, useMemo } from 'react';
import {
	type FieldValues,
	FormProvider as ReactHookFormProvider,
	type UseFormReturn,
} from 'react-hook-form';

import { useRequiredContext } from 'hooks';

interface FormProviderProps {
	formLocation: string;
}
const FormContext = createContext<FormProviderProps | undefined>(undefined);

interface Props<T extends FieldValues> {
	children: ReactNode;
	form: UseFormReturn<T, unknown, T>;
	formLocation: string;
}

export default function FormProvider<T extends FieldValues>({
	children,
	form,
	formLocation,
}: Props<T>) {
	const value = useMemo(() => ({ formLocation }), [formLocation]);
	return (
		<FormContext value={value}>
			<ReactHookFormProvider {...form}>{children}</ReactHookFormProvider>
		</FormContext>
	);
}
FormProvider.displayName = 'ReactHookForm_FormProvider';

export function useFormContext() {
	return useRequiredContext(FormContext, 'FormContext');
}
